
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    import dayjs from 'dayjs';
    import { jobData } from '@/utils/jobData';
    import datalayer from '@/utils/datalayer';
    import LoginRegister from '@/components/Auth/LoginRegister';

    export default {
        name: 'ApplyMandatoryLogin',

        components: {
            LoginRegister,
        },

        data() {
            return {
                login_redirect: '_self',
                getNewJobAlert: true,
                user: {
                    email: '',
                },
                saveSearchData: {
                    name: '',
                    search_filters: {},
                    search_url: '',
                },
            };
        },

        computed: {
            ...mapState({
                $_authOptions: state => state.auth.authOptions,
                $_job: state => state.job.job,
                $_me: state => state.me.user,
                $_tracking: state => state.eventTracking,
            }),

            ...mapGetters('jobModal', {
                $_isJobModalOpen: 'isJobModalOpen',
            }),

            isModal() {
                return this.$_isJobModalOpen;
            },

            getOffsiteApplyUrl() {
                return `${this.$siteUrl}job-redirect/${this.$_job.uuid}?flow=${this.$_job.flow_enabled === 'FLOW'}&token=${this.$_job.token}&source='button&page_referral_element=${this.$_tracking.page_referral_element}`;
            },
        },

        mounted() {
            if (this.$route.name !== 'discover') {
                this.login_redirect = {
                    name: 'discover',
                    query: {
                        uuid: this.$_job.uuid,
                    },
                };
            }

            if (!this.$_me.id) {
                this.eventJobApplyAuthImpression();
            }
        },

        methods: {
            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            ...mapMutations('job', {
                $_UPDATE_JOB: 'UPDATE_JOB',
            }),

            ...mapMutations('me', {
                $_PUT_JOB_EVENT: 'PUT_JOB_EVENT',
            }),

            onOffsiteRedirect() {
                this.eventJobOffsiteApplyRedirect();
                window.open(this.getOffsiteApplyUrl, '_blank');
                this.$emit('onOffSiteApplyComplete');
                this.$_UPDATE_JOB({ key: 'has_applied', value: true });
                this.$_UPDATE_JOB({ key: 'applied_at', value: dayjs().format('YYYY-MM-DD HH:mm:ss') });
                this.$_PUT_JOB_EVENT({ job: this.$_job.uuid, status: 'is_applied' });
            },

            eventSkipClick() {
                const data = {
                    site_position: this.$_authOptions.sitePosition,
                    site_position_label: 'terms_and_conditions',
                    event: 'skip_click',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
                this.eventJobOffsiteApplyRedirect();
            },

            eventJobOffsiteApplyRedirect() {
                const data = {
                    event: 'job_offsite_apply_redirect',
                    site_position: 'job_apply',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            eventJobApplyAuthImpression() {
                const data = {
                    event: 'job_apply_auth_impression',
                    site_position: 'job_apply',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            loginResponse(response) {
                this.$emit('afterLogin', response);
            },
        },
    };
